<script setup>
import { serviziData } from '@/graphql/queries/servizi.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(serviziData, variables)

if (!data.value.servizi || !data.value.allListaServizis) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.servizi)
const lista = computed(() => data?.value.allListaServizis || {})
const ambiti = computed(() => data?.value.allListaAmbitis || [])

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="servizi-page p-top-1a">
    <p v-if="page.titolo" class="intro-page-title text-3 row-400-20 max">
      {{ page.titolo }}
    </p>
    <IntroPagine v-if="page.intro" :intro="page.intro" />
    <div class="black-bg">
      <PagineServiziServiziList v-if="lista" :lista-servizi="lista" />
      <AddaBlock />
      <PagineServiziEndPageSection v-if="ambiti" :ambiti="ambiti" />
    </div>
  </div>
</template>
